import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { PrivateRoute } from "../app/PrivateRoute";
import { getUser, hideLeftNav } from "../../helpers";
import LoginContainer from "../login/LoginContainer";
import PageNotFoundView from "../PageNotFound/PageNotFoundView";
import ClinicListContainer from "../Clinics/ClinicListContainer";
import ClinicDetailsTabsContainer from "../ClinicsDetailsTabs/ClinicDetailsTabsContainer";
import DoctorDetailsTabsContainer from "../DoctorDetailsTabs/DoctorDetailsTabsContainer";
import MetricsContainer from "../ClinicDetailsComponents/Metrics/MetricsContainer";
import PharmacyListContainer from "../Pharmacy/PharmacyListContainer";
import DoctorsListContainer from "../Doctors/DoctorsListContainer";
import DemoDetailContainer from "../demo/DemoDetailContainer";
import LabListContainer from "../Labs/LabListContainer";
import LabDetailsTabsContainer from "../Labs/LabDetail/LabDetailsTabContainer";
import PharmacyDetailTabContainer from "../Pharmacy/PharmacyDetail/PharmacyDetailTabContainer";
import UsersListContainer from "../Users/UsersListContainer";
import UsersDetailsContainer from "../UsersDetails/UsersDetailsContainer";
import PromoCodeListContainer from "../PromoCode/PromoCodeListContainer";
import DeploymentContainer from "../Deployment/DeploymentContainer";
import NewsFeedListContainer from "../NewsFeed/NewsFeedListContainer";
import WeeklyStatusContainer from "../NewsFeed/WeeklyStatusContainer";
import AnalyticsContainer from "../NewsFeed/Analytics/AnalyticsContainer";
import NewsInterestsContainer from "../NewsFeed/NewsInterestsContainer";
import PatientReferralContainer from "../PatientReferrals/PatientReferralContainer";
import WeeklyNewsContainer from "../NewsFeed/WeeklyNewsContainer";
import CareCities from "../CareCities";
import AdCampaignContainer from "../AdCampaigns/AdCampaignContainer";
import LeadsContainer from "../CampaignLeads/LeadsContainer";
import Universities from "../Universities";
import ReleaseNotesContainer from "../../ReleaseNotes/ReleaseNotesContainer";

class AppContent extends Component {
  render() {
    const role = localStorage.getItem("account_type");
    return (
      <div
        className={
          getUser() && !hideLeftNav() ? "content ant-layout-content" : ""
        }
      >
        {/* Base page is login page for logged out user and dashboard for logged in user with doctor profile */}
        <Switch>
          <Route
            exact
            path="/"
            render={() =>
              getUser() ? <Redirect to="/clinics" /> : <LoginContainer />
            }
          />

          {/* <Route path="/sign-in" component={LoginContainer} /> */}
          <PrivateRoute path="/clinics" component={ClinicListContainer} />
          <PrivateRoute
            path="/clinics-details/:clinicId/basic-details"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/basic-details"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/metrics"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/doctors"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/bank-details"
            component={ClinicDetailsTabsContainer}
          />

          <PrivateRoute
            path="/clinics-details/:clinicId/staff"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/admins"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/locations"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/payments"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/audit-trail-summary"
            component={ClinicDetailsTabsContainer}
          />
          <PrivateRoute
            path="/clinics-details/:clinicId/list-audit-trail"
            component={ClinicDetailsTabsContainer}
          />

          <PrivateRoute
            path="/doctor-details/:doctorId/basic-details/:clinicId/:clinicDocId"
            component={DoctorDetailsTabsContainer}
          />
          <PrivateRoute
            path="/doctor-details/:doctorId/clinics/:clinicId/:clinicDocId"
            component={DoctorDetailsTabsContainer}
          />
          <PrivateRoute
            path="/doctor-details/:doctorId/clinic-doctor/:clinicId/:clinicDocId"
            component={DoctorDetailsTabsContainer}
          />
          <PrivateRoute
            path="/doctor-details/:doctorId/basic-details"
            component={DoctorDetailsTabsContainer}
          />
          <PrivateRoute
            path="/doctor-details/:doctorId/clinics"
            component={DoctorDetailsTabsContainer}
          />

          <PrivateRoute path="/pharmacies" component={PharmacyListContainer} />

          <PrivateRoute
            path="/pharmacy-details/:pharmacyId/basic-details"
            component={PharmacyDetailTabContainer}
          />
          <PrivateRoute
            path="/pharmacy-details/:pharmacyId/metrics"
            component={PharmacyDetailTabContainer}
          />
          <PrivateRoute
            path="/pharmacy-details/:pharmacyId/clinics"
            component={PharmacyDetailTabContainer}
          />
          <PrivateRoute path="/doctors" component={DoctorsListContainer} />
          {role === "super_admin" && (
            <PrivateRoute path="/demo" component={DemoDetailContainer} />
          )}

          <PrivateRoute path="/labs" component={LabListContainer} />

          <PrivateRoute
            path="/lab-details/:labId/basic-details"
            component={LabDetailsTabsContainer}
          />
          <PrivateRoute
            path="/lab-details/:labId/metrics"
            component={LabDetailsTabsContainer}
          />
          <PrivateRoute
            path="/lab-details/:labId/clinics"
            component={LabDetailsTabsContainer}
          />
          {role === "billing_admin" && (
            <PrivateRoute path="/users" component={UsersListContainer} />
          )}
          {role === "super_admin" && (
            <PrivateRoute path="/users" component={UsersListContainer} />
          )}
          {role === "billing_admin" && (
            <PrivateRoute
              path="/users-details/:userid"
              component={UsersDetailsContainer}
            />
          )}
          {role === "super_admin" && (
            <PrivateRoute
              path="/users-details/:userid"
              component={UsersDetailsContainer}
            />
          )}

          {role === "billing_admin" && (
            <PrivateRoute
              path="/promo-code"
              component={PromoCodeListContainer}
            />
          )}
          {role === "super_admin" && (
            <PrivateRoute
              path="/promo-code"
              component={PromoCodeListContainer}
            />
          )}

          {role === "super_admin" && (
            <PrivateRoute path="/web-upgrade" component={DeploymentContainer} />
          )}
          <PrivateRoute path="/news-feed" component={NewsFeedListContainer} />

          <PrivateRoute
            path="/weekly-status"
            component={WeeklyStatusContainer}
          />
          <PrivateRoute path="/analytics" component={AnalyticsContainer} />
          <PrivateRoute
            path="/saved_articles"
            component={NewsInterestsContainer}
          />
          <PrivateRoute
            path="/referrals"
            component={PatientReferralContainer}
          />

          <PrivateRoute path="/weekly-news" component={WeeklyNewsContainer} />
          <PrivateRoute path="/care-cities" component={CareCities} />

          <PrivateRoute path="/ad-campaigns" component={AdCampaignContainer} />
          <PrivateRoute path="/campaign-leads" component={LeadsContainer} />
          <PrivateRoute path="/universities" component={Universities} />

          {(role === "super_admin" || role === "billing_admin") && (
            <PrivateRoute
              path="/release-notes"
              component={ReleaseNotesContainer}
            />
          )}

          {/* 404 - Page not found */}
          <Route component={PageNotFoundView} />
        </Switch>
      </div>
    );
  }
}

export default AppContent;
